<template>
  <!-- start 自定义输入框 -->
  <div class="custom-input">
    <div class="custom-input-content">
      <input class="transparent-input" v-model="value" />
      <div class="val-content">
        <div class="val-container">
          <div class="val-list" v-for="(item,key) in convertedData" :key="key">{{item}}</div>
        </div>
        <!-- start 光标 -->
        <div
          class="cursor"
          :style="{ visibility: cursor ? 'visible' : 'hidden' }"
        ></div>
        <!-- end 光标-->
      </div>
    </div>
  </div>
  <!-- end 自定义输入框 -->
</template>

<script>
export default {
  name: "CustomInput",
  data() {
    return {
      value: null,
      // 闪烁标记
      cursor: false,
      // 光标定时器对象
      intervalID: null,
      // 光标闪烁间隔时间
      cursorDuration: 600,
      // 转换后数据
      convertedData: [],
    };
  },
  props: {
    isCursor: {
      typeof: Boolean,
      default: true,
    },
  },
  watch: {
    // 是否获取光标
    isCursor: {
      immediate: true,
      handler(newval) {
        if (newval) {
          this.cursorFlashing();
        }
      },
    },
    // 监听输入值
    value: {
      immediate: true,
      handler(newval) {
        if (newval == "" || newval == null) {
          this.convertedData = [];
          return;
        }
        let valArr = newval.split("");
        if (valArr.length != 0) {
          this.convertedData = valArr;
        }
      },
    },
  },
  methods: {
    // 光标闪烁
    cursorFlashing() {
      clearInterval(this.intervalID);
      this.intervalID = setInterval(() => {
        this.cursor = !this.cursor;
      }, this.cursorDuration);
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-input {
  width: 200px;
  height: 40px;
  border: 1px solid grey;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  .custom-input-content {
    width: 100%;
    height: 100%;
    position: relative;
    .transparent-input {
      opacity: 0;
      position: absolute;
      z-index: 996;
      width: 100%;
      height: 100%;
      border: none;
      padding: 0;
    }
    .val-content {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0px;
      display: flex;
      align-items: center;
      z-index: 990;
      padding: 0px 10px;
      box-sizing: border-box;
      .val-container{
        display: flex;
        .val-list{
          text-align: center;
          width: 16px;
          font-size: 18px;
        }
      }
      .cursor {
        background-color: #000000;
        width: 1px;
        height: 18px;
      }
    }
  }
}
</style>
